import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const KEY = 'ept_cookie_consent';

const applyConsent = (value) => {
  if (value === 'essential') {
    window.adsbygoogle = window.adsbygoogle || [];
    window.adsbygoogle.requestNonPersonalizedAds = 1;
  }
};

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let stored = null;
    try { stored = localStorage.getItem(KEY); } catch { /* noop */ }
    if (stored) {
      applyConsent(stored);
    } else {
      setVisible(true);
    }
  }, []);

  const choose = (value) => {
    try { localStorage.setItem(KEY, value); } catch { /* noop */ }
    applyConsent(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[100] bg-[#0a0d15]/98 backdrop-blur-md border-t border-[#00F0FF]/20 p-4 sm:p-5"
      data-testid="cookie-banner"
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="text-[#00F0FF] shrink-0 mt-0.5" size={20} />
          <p className="text-xs sm:text-sm text-slate-300 leading-relaxed">
            Usiamo cookie tecnici e, con il tuo consenso, cookie di terze parti (Google AdSense) per
            mostrare annunci personalizzati. Rifiutando vedrai solo annunci non personalizzati.{' '}
            <Link to="/privacy" className="text-[#00F0FF] underline" data-testid="cookie-privacy-link">
              Privacy &amp; Cookie Policy
            </Link>
          </p>
        </div>
        <div className="flex gap-2 shrink-0">
          <button
            onClick={() => choose('essential')}
            className="px-4 py-2 text-xs uppercase tracking-wider border border-white/20 text-slate-300 hover:bg-white/5 transition-colors"
            data-testid="cookie-reject-btn"
          >
            Solo necessari
          </button>
          <button
            onClick={() => choose('all')}
            className="px-4 py-2 text-xs uppercase tracking-wider bg-[#00F0FF] text-black font-bold hover:bg-[#00F0FF]/90 transition-colors"
            data-testid="cookie-accept-btn"
          >
            Accetta tutti
          </button>
        </div>
      </div>
    </div>
  );
};
